import {useGetUserSettingsHook} from '../../generated/src/GetUserSettings/get.hook';

export const useUserSettings = () => {
    const {isLoading, data} = useGetUserSettingsHook();

    return {
        isLoading,
        data: data?.data,
    };
};
